import script from "./RegistrationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationView.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationView.vue?vue&type=style&index=0&id=18b2dbe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b2dbe4"]])

export default __exports__